if (!customElements.get('hs-restock-carousel')) {
  customElements.define('hs-restock-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.hs-restock-products');
      this.cards = [...this.track.children];
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.status = this.querySelector('[data-status]');
      this.onPrev = () => this.move(-1);
      this.onNext = () => this.move(1);
      this.onScroll = () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.updateControls());
      };
      this.prev.addEventListener('click', this.onPrev);
      this.next.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.classList.add('is-ready');
      this.observer = new ResizeObserver(() => {
        const width = this.track.clientWidth;
        if (width === this.lastWidth) return;
        this.lastWidth = width;
        this.count = window.matchMedia('(max-width: 749px)').matches
          ? 2 : Math.max(1, Math.min(4, Math.floor((width + 20) / 200)));
        this.track.style.setProperty('--restock-columns', this.count);
        this.track.scrollTo({ left: 0, behavior: 'instant' });
        this.updateControls();
      });
      this.observer.observe(this.track);
      this.imageFrame = this.cards[0]?.querySelector('.card__inner');
      if (this.imageFrame) {
        this.imageObserver = new ResizeObserver(() => this.updateArrowPosition());
        this.imageObserver.observe(this.imageFrame);
      }
      this.updateArrowPosition();
    }
    updateArrowPosition() {
      if (!this.imageFrame) return;
      const image = this.imageFrame.getBoundingClientRect();
      const carousel = this.getBoundingClientRect();
      this.style.setProperty('--restock-image-center', (image.top - carousel.top + image.height / 2) + 'px');
    }
    move(direction) {
      const step = this.cards.length > 1
        ? this.cards[1].offsetLeft - this.cards[0].offsetLeft
        : this.track.clientWidth;
      const index = Math.round(this.track.scrollLeft / step);
      const target = Math.max(0, Math.min(this.cards.length - 1, index + direction * this.count));
      this.track.scrollTo({
        left: target * step,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      });
    }
    updateControls() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= maxScroll - 2;
      this.querySelector('.hs-restock-controls').hidden = maxScroll <= 2;
      const step = this.cards.length > 1
        ? this.cards[1].offsetLeft - this.cards[0].offsetLeft
        : this.track.clientWidth;
      const first = Math.max(0, Math.round(this.track.scrollLeft / step));
      this.status.textContent = `${first + 1}?${Math.min(first + this.count, this.cards.length)} / ${this.cards.length}`;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.imageObserver?.disconnect();
      cancelAnimationFrame(this.scrollFrame);
      this.track?.removeEventListener('scroll', this.onScroll);
      this.prev?.removeEventListener('click', this.onPrev);
      this.next?.removeEventListener('click', this.onNext);
    }
  });
}
